export default function () {
  const widgetName = 'cardWidgetSeo';
  const widgetOpts = cardWidgetSeoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (slide, owl, hasData) {

      let subtitleContent = slide.items[0].DetailLinkText
      let chartLimit = 40

      if ((slide.items[0].DetailLinkText).length > chartLimit) {
        subtitleContent = `${subtitleContent.substring(0, chartLimit)}...`
      } else {
        subtitleContent = subtitleContent.substring(0, chartLimit)
      }


      let data = `<div class="card-widget-subtitle">${subtitleContent}</div>`

      function customizeWidget() {
        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).find('.card-widget-title').after('<div class="seo-abstract"></div>')
          $(this).find('.card-widget-title').after(data);
          $(this).find('.card-widget-title, .seo-abstract').wrapAll('<div class="wrap-title"></div>')



        })
      }
      customizeWidget()

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'Get Directions'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });

}